import { AppContext } from "contexts/AppContext";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { callAPI } from "utils/API";
import './Package.css'
import _ from 'lodash'
import { translate } from "utils/Translate";
import ButtonMedium4 from "components/elements/ButtonMedium4";
import Headline6 from "components/elements/Headline6";
import ContentNormal from "components/elements/ContentNormal";
import IconButtonLarge from "components/elements/IconButtonLarge";
import Heart2 from "components/icons/Heart2";
import Cart1 from "components/icons/Cart1";
import ButtonLarge1 from "components/elements/ButtonLarge1";
import ButtonInactive from "components/elements/ButtonInactive";
import { parseLinks, priceConvertor } from "utils/general";
import { addPackageToBasket, updateProductQuantityInBasket, basketHasRoomforMoreProducts, isOrderLimitExhausted } from "utils/basket";
import { setupBasketData } from "utils/setup";
import FreightInfo from "modules/basket/FreightInfo";
import { TaxPercentageForm } from "components/blocks/taxPercentageForm/TaxPercentageForm";
import ProductContainer from "modules/product/ProductContainer";
import ContentExtraSmall from "components/elements/ContentExtraSmall";
import { Alert, Box, OutlinedInput } from "@mui/material";
import CaptionText from "components/elements/CaptionText";
import QuantityInput from "components/elements/QuantityInput";

function Package1(props) {
    const {checkBasketForOnePointUser, freightInfo} = props
    const { PackageID } = useParams()
    const { styleGuide, accessibleShops, basket, userData, setBasket, brandData, langCode, setshowBasketQuickView } = useContext(AppContext)

    const defaultCarouselInterval = 1000
    const ShopIDs = accessibleShops.map(item => item.ShopID)
    const summaryContentLength = 200

    const [packageDetails, setPackageDetails] = useState({})
    const [packageProducts, setPackageProducts] = useState([])
    const [packageStock, setPackageStock] = useState(undefined)
    const [viewMore, setViewMore] = useState(false)
    const [ShopID, setShopID] = useState(accessibleShops && accessibleShops.length > 0 ? accessibleShops[0].ShopID : null)
    const [isFreightInfoExpanded, setIsFreightInfoExpanded] = useState(false);
    const [basketIsLoading, setBasketIsLoading] = useState(false)
    const [selectedQuantity, setSelectedQuantity] = useState(1);
    const [selectedVariationInBasket, setselectedVariationInBasket] = useState(null)
    const [userNote, setUserNote] = useState('');
    const [productReactionLoading, setProductReactionLoading] = useState(false) 

    const pointSuffix = translate("_POINTS_SHORT_", "pt")
    const dkkSuffix = translate("_DKK_", "kr")
    const headerSpacing = 10
    const price = packageDetails.sellingPrice

    const handleFreightExpandChange = (expand) => {
        setIsFreightInfoExpanded(expand) // Update parent state with the expand value
    }

    const shopProductLimit = () => {
        let shop = accessibleShops?.filter(shop => shop?.ShopID === packageDetails?.ShopID)
        shop = shop?.length ? shop[0] : null
        return shop?.shopSelectionLimit || 0
    }

    const fetchPackageDetails = async () => {
        if (!PackageID) return;
        let packageInfo = await callAPI(`/shop/${ShopID}/productPackages/${PackageID}`, "GET");
        if(packageInfo && packageInfo.ProductPackageID) {
            let images = packageInfo.image ? [packageInfo.image] : []
            packageInfo.products.forEach((item) => {
                if(!!item.images.length) {
                    item.images.forEach((im) => {
                        images.push(im)
                    })
                }
            })
            packageInfo.images = images
            let variationsArrObj = {}
            packageInfo.products.map((item) => {
                let sizes = []
                let colors = []
                let titles = []
                if(!item || !item.variations || !item.variations.length) {
                    return
                }
                item.variations.forEach(variation => {
                    variation.ImageID = variation.images && variation.images.length ? variation.images.map(img => img.ImageID)[0] : null
                    variationsArrObj[variation.VariationID] = variation
                });
                
                item.variations.sort((a,b) => a.poolOrder - b.poolOrder).map(vr => {
                    const available = !vr.limitedStock ? true : !vr.variationStock ? false : true
                    const colorName = vr.colorName
                    if(!sizes.filter(v => v.variant === vr.variationSize).length) !!vr.variationSize && sizes.push({variant: vr.variationSize, available })
                    if(!colors.filter(v => v.variant === vr.colorHexcode).length) !!vr.colorHexcode && colors.push({variant: vr.colorHexcode, available, colorName: colorName })
                    if(!titles.filter(v => v.variant === vr.variationTitle).length) !!vr.variationTitle && titles.push({variant: vr.variationTitle, available})
                })
                item.selectedVariation = item.variations[0]
                item.isSingleVariation = item.variations.length === 1
                item.variations = {sizes, colors, titles}
            })
            setPackageDetails(packageInfo || {})
        }
        return;
    }

    const packageReaction = async (productPackage) => {
        setProductReactionLoading(true)
        const ReactionID = productPackage.reaction ? productPackage.reaction.ReactionID : null
        const reactionResponse = await callAPI("/productPackages/reaction", "POST", { body: { ReactionTargetID: productPackage.ProductPackageID, reactionData: JSON.stringify({ ShopID: ShopID }), ...(ReactionID && { ReactionID }) } })
        if(reactionResponse !== false) {
            if(reactionResponse?.insertId === 0) {
                productPackage.reaction = null
            } else if (reactionResponse?.insertId) {
                productPackage.reaction = {
                    ReactionID: reactionResponse.insertId
                }
            }
        }
        setProductReactionLoading(false)
    }

    const addToCart = async () => {
        if(isOrderLimitExhausted(accessibleShops.find(s => s.ShopID === ShopID))){
            return
        }
        if(!checkBasketForOnePointUser()){
            return
        }

        setBasketIsLoading(true)

        if(!selectedVariationInBasket || userNote.length) {
            await addPackageToBasket(ShopID, packageDetails.ProductPackageID, selectedQuantity, userNote)
        } else {
            await updateProductQuantityInBasket(selectedVariationInBasket.BasketID, selectedVariationInBasket.amount + selectedQuantity)
        }

        await setupBasketData({userData, setBasket})
        setshowBasketQuickView(true)
        setUserNote('')

        setBasketIsLoading(false)
    }

    const getPackageStock = () => {
        const packageContainsUnavailableProduct = packageDetails.products.some(p => p.productStatus === 'UNAVAILABLE')
        if(packageContainsUnavailableProduct) {
            return 0
        }

        const productsWithLimitedStock = packageDetails.products.filter(p => p.selectedVariation.limitedStock) || []
        if(!productsWithLimitedStock.length) {
            return undefined
        }

        const productIdToAmount = {}
        for(const product of packageDetails.products) {
            if(productIdToAmount[product.ProductID]) {
                productIdToAmount[product.ProductID] += 1
            } else {
                productIdToAmount[product.ProductID] = 1
            }
        }

        let availableStockForPackage = undefined
        for(const product of productsWithLimitedStock) {
            const stock = Math.floor(product.selectedVariation.variationStock / productIdToAmount[product.ProductID])
            availableStockForPackage = availableStockForPackage === undefined ? stock : Math.min(availableStockForPackage, stock)
        }

        return availableStockForPackage
    }

    const packageAlreadyInBasket = () => {
        return basket.find(item => item.ProductPackageID === packageDetails.ProductPackageID)
    }
    
    useEffect(() => {
        const productsByProductId = []
        if(packageDetails?.products) {
            for(const product of packageDetails?.products){
                if (!productsByProductId.some(p => p.product.ProductID === product.ProductID)) {
                    productsByProductId.push({product: product, amount: 1})
                } else {
                    productsByProductId.find(p => p.product.ProductID === product.ProductID).amount += 1
                }
            }
        }
        setPackageProducts(productsByProductId)
        setselectedVariationInBasket(packageAlreadyInBasket())
    }, [packageDetails])

    useEffect(() => {
        setShopID(ShopIDs[0])
    },[ShopIDs])

    useEffect(() => {
        if(ShopID) {
            fetchPackageDetails()
        }
    }, [ShopID])

    useEffect(() => {
        if(packageDetails.products?.length) {
            setPackageStock(getPackageStock())
        }
    },[packageDetails.products])

    useEffect(() => {
        setselectedVariationInBasket(packageAlreadyInBasket())
    }, [basket]);

    if (isNaN(PackageID) || !packageDetails || !packageDetails.ProductPackageID){
        return null
    }

    return (
        <ProductContainer
            interval={defaultCarouselInterval}
            productDetails={{...packageDetails, elementTitle: packageDetails.title}}
            ShopID={ShopID}
        >
            <Headline6 style={{ marginTop: 10, color: styleGuide.color6 }}>{packageDetails.shortDescription || ' '}</Headline6>
            
            <Box marginTop={2}>
                {packageProducts.map(p => {
                    return (
                        <Box key={p.product.ProductID} display={'flex'} flexDirection={'column'} marginBottom={2}>
                            <ContentNormal fallbackText={`${p.amount > 1 ? `${p.amount}x ` : ''}${p.product.elementTitle}`} />
                            { p.product.manufacturer && <ContentExtraSmall fallbackText={p.product.manufacturer} /> }
                        </Box>
                    )
                })}
            </Box>

            <CaptionText
                style={{ color: styleGuide.color6, marginTop: 20 }}
                translationKey="_PRODUCT_QUANTITY_LABEL_"
                fallbackText="Antal" // Quantity Label
            />
            <Box style={{ marginTop: headerSpacing }}>
                <QuantityInput
                    variantionStock={packageStock}
                    quantity={selectedQuantity}
                    setQuantity={setSelectedQuantity}
                    shopLimit={shopProductLimit()}
                    disabled={packageStock <= 0}
                />
            </Box>

            {!!packageDetails.enableUserNote &&
                <Box display={'flex'} flexDirection={'column'} gap={1} sx={{ marginTop: 2 }}>
                    <CaptionText
                        style={{ color: styleGuide.color6 }}
                        translationKey="_PRODUCT_USER_NOTE_LABEL_"
                        fallbackText="Note"
                    />
                    <OutlinedInput
                        multiline
                        value={userNote}
                        onChange={v => setUserNote(v.target.value)}
                        style={{
                            borderRadius: 14,
                            border: `1px solid ${styleGuide.color4}`,
                            fontSize: '14px',
                            padding: '10px',
                            width: 250,
                        }}
                    />
                </Box>
            }

            <Box marginTop={4}>
                {brandData?.features?.retailPrice && packageDetails?.retailPrice &&
                    <ContentNormal skipTranslation={true} style={{ color: styleGuide.color7, marginBottom: 20 }}>Vejl. udsalgspris: Kr. {packageDetails.retailPrice} inkl. moms</ContentNormal>
                }

                { packageStock <= 0 &&
                    <Box width={200} marginTop={1}>
                        <Alert severity="error"> {'Ikke flere på lager'}</Alert>
                    </Box>
                }

                { !!packageStock &&
                    <Box marginTop={1}>
                        <ContentExtraSmall skipTranslation={true} style={{ color: styleGuide.color6 }}>{packageStock} stk. på lager</ContentExtraSmall>
                    </Box>
                }
            </Box>
            
            <Box display={'flex'} flexDirection={'row'} marginBottom={10} marginTop={1} gap={1}>
                {!brandData?.features?.disableWishlist &&
                    <IconButtonLarge
                        inverse={packageDetails?.reaction?.ReactionID > 0}
                        icon={<Heart2 fill='white' stroke={styleGuide.color7} strokeWidth="1.5px" />}
                        onClick={() => packageReaction(packageDetails)}
                        loading={productReactionLoading}
                    />
                }
                {basketHasRoomforMoreProducts(basket, accessibleShops.find(s => s.ShopID === ShopID)) && !isOrderLimitExhausted(accessibleShops.find(s => s.ShopID === ShopID))
                    ? brandData?.features?.points !== false &&
                        <ButtonLarge1
                            loading={basketIsLoading}
                            onClick={addToCart}
                            disabled={packageStock <= 0}
                            icon={<Cart1 fill={styleGuide.color1} style={{ marginLeft: '64px' }} />}
                            fallbackText={!!brandData?.features?.disablePrice
                                ? brandData?.features?.productButtonText[langCode]
                                : !brandData?.features?.disablePoints
                                    ? priceConvertor(brandData, `${price.amount}`, price.type === 'POINTS' ? pointSuffix : dkkSuffix)
                                    : translate("_ADD_TO_CART_BUTTON_TOOLTIP_", "Læg i kurv")
                            }
                        />
                    :
                        <ButtonInactive
                            buttonText='Du kan ikke vælge flere'
                            style={{ height: '45px', width: '80%' }}
                            disabled={true}
                        />
                }
            </Box>

            { !userData?.taxPercentage && <TaxPercentageForm /> }

            { !!freightInfo?.enableFreightPriceInterval &&
                <div style={{ marginTop: headerSpacing }}>
                    <FreightInfo freightIntervals={freightInfo.freightIntervals} showAdditionalInfo showLoadFreight onExpandChange={handleFreightExpandChange} />
                </div>
            }

            <div style={{marginBottom: 40}} />

            <Headline6 style={{ color: styleGuide.color7 }}>
                {translate('_PRODUCT_DESCRIPTION_TAB_CAPTION_', 'Beskrivelse')}
            </Headline6>
            <Box style={{ display: 'flex', flexDirection: 'column', marginTop: headerSpacing }}>
                <ContentExtraSmall skipTranslation={true}>{viewMore ? parseLinks(packageDetails.fullDescription) : parseLinks(_.truncate(packageDetails.fullDescription, { length: isFreightInfoExpanded ? 50 : summaryContentLength }))}</ContentExtraSmall>
                { !!packageDetails.fullDescription && packageDetails.fullDescription.length > summaryContentLength && 
                    <div>
                        <ButtonMedium4
                            style={{ marginTop: 20 }}
                            fallbackText={viewMore ? translate('_READ_LESS_BUTTON_TEXT_', 'Læs mindre') : translate('_READ_MORE_BUTTON_TEXT_', 'Læs mere')}
                            showIcon={false}
                            onClick={() => setViewMore(!viewMore)}
                        />
                    </div>
                }
            </Box>
        </ProductContainer>
    )
}

export default Package1;
